import { Button, ButtonProps } from '@chakra-ui/react';
import NextLink from 'next/link';
import * as React from 'react';

export const ViewConferenceButton = React.forwardRef<
  HTMLButtonElement,
  { eventId: string } & ButtonProps
>(function ViewConferenceButton({ eventId, children, ...props }, ref) {
  return (
    <NextLink href={`/events/conferences/${eventId}`}>
      <Button {...props} ref={ref}>
        {children ? children : 'View Event'}
      </Button>
    </NextLink>
  );
});
